import axios from 'axios'

const CancelToken = axios.CancelToken
let validateAddressCancelFunction

export default {
  async getAddressByZipcodeAndHousenumber(zipcode, houseNumber, houseNumberSuffix) {
    validateAddressCancelFunction && validateAddressCancelFunction()

    try {
      const result = await axios.post(
        `ValidateAddress?zipcode=${zipcode}&houseNumber=${houseNumber}`,
        null,
        {
          cancelToken: new CancelToken((c) => {
            validateAddressCancelFunction = c
          }),
        }
      )

      if (result.status == 200) return result.data
    } catch (e) {
      if (axios.isCancel(e)) return null
    }

    return null
  },
}
